export function SioFestFloatingButton() {
    return (
        <a
            href="https://www.siofest.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="fixed bottom-0 right-0 z-50 flex h-36 w-36 translate-x-6 translate-y-6 cursor-pointer items-center justify-center rounded-full bg-white p-3 shadow-xl transition-transform duration-300 ease-out origin-bottom-right hover:scale-110 md:h-72 md:w-72 md:translate-x-12 md:translate-y-12 md:p-6"
        >
            <img
                src="/img/siofest.png"
                alt="SioFest"
                className="h-[70%] w-[70%] rounded-full object-cover"
            />
        </a>
    );
}
